import CONSTANTS from "../CONSTANTS";

export const actionGetDoctors = () => ({
    type: CONSTANTS.DOCTORS_GET_LIST
});
export const actionSetDoctors = doctors => ({
    type: CONSTANTS.DOCTORS_SET_LIST,
    doctors
});